var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightsS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/flights-S ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/flights-S-",
    fill: "#B3D6E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.04,13.92 L9.99733333,24 L8.664,23.4333333 L10,14.6666667 L10,13.7026667 C7.45466667,13.5733333 5.152,13.428 4,13.3333333 C1.49866667,13.128 1.33733333,12.0346667 1.33333333,12.0013333 L1.33333333,12 L0,6.66666667 L1.95733333,6.00666667 L4.7,10.6133333 C5.95866667,10.5226667 7.89733333,10.404 10,10.2973333 L10,9.33333333 L8.664,0.566666667 L9.99733333,0 L15.04,10.08 C16.4066667,10.0333333 17.6666667,10.0053333 18.6666667,10.0053333 C22.6533333,10.0053333 23.9946667,10.6426667 24,11.992 L24,12 C24,13.3546667 22.6613333,13.9946667 18.6666667,13.9946667 C17.6666667,13.9946667 16.4066667,13.9666667 15.04,13.92 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightsS);
export default __webpack_public_path__ + "static/media/flights-S.d4343aa143e0a6462e9725d0e7ffeb55.svg";
export { ForwardRef as ReactComponent };